import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator';
import store from '@/assets/common/store/store';

export type Item = {
    id: string;
    name: string;
    isActive: boolean;
}

@Component
export default class List extends Vue {
    private placeholder = ''
    private items: Item[] | undefined = []
    private searchText = ''
    private checked = false;
    private dataHeight = { height: '0px' }

    @Prop({ default: () => [] })
    private list!: []

    @Prop()
    private id!: string

    @Prop({ default: () => true })
    private isAddVisible!: boolean

    @Prop({ default: () => false })
    private isBulkVisible!: boolean

    @Prop({ default: () => false})
    private isDisplayVisible!: boolean;

    @Prop({ default: () => true})
    private isSearchVisible!: boolean;

    @Prop()
    private title!: string

    @Prop()
    private withHidden!: boolean;

    @Emit('checkboxChanged')
    private checkboxChanged() {
        return this.checked;
    }


    private created() {
        this.items = this.list
        this.placeholder = this.title + 'の検索'
        this.checked = this.withHidden;
        if(this.id) {
            this.sendItem(this.id)
        }
    }

    private mounted() {
        this.calcDataHeight()
        window.addEventListener('resize', this.calcDataHeight)
    }
    private beforeDestroy(): void {
        window.removeEventListener('resize', this.calcDataHeight)
    }

    @Emit('btnAction')
    private btnAction() {
        const newItems: Item[] = []
        this.items?.forEach((val) => {
            val.isActive = false
            newItems.push(val)
        })
        this.items = newItems
    }

    @Emit('bulkBtnAction')
    private bulkBtnAction() {
        return true;
    }

    @Emit('selectItem')
    private sendItem(itemId: string) {
    setTimeout(() => {
        if(store.getters.isInputChanged==false){
        const newItems: Item[] = []
        this.items?.forEach((val) => {
            if(itemId === val.id){
                val.isActive = true
            }else {
                val.isActive = false
            }
            newItems.push(val)
        })
        this.items = newItems
        return  itemId
     }
    }, 100);
    }

    @Watch('searchText')
    private doSearch() {
        if(this.searchText){
            this.items = this.list?.filter((item: Item) => item.name.indexOf(this.searchText) > -1)
        }else {
            this.items = this.list
        }
    }

    // 要素内スクロール制御のためリストデータ部の高さを計算
    private calcDataHeight() {
        let diff = 0
        // ボタンの表示有無で高さが変わるためヘッダー部、フッター部の要素の高さを取得する
        const headerHeight = (this.$refs.header as HTMLElement)?.offsetHeight ?? 0
        const footerHeight = (this.$refs.footer as HTMLElement)?.offsetHeight ?? 0
        diff = diff + headerHeight + footerHeight
        this.dataHeight = { height: `calc(100% - ${diff}px` }
    }
}